// Section1.js
import React from 'react';
import { FaWhatsapp } from "react-icons/fa";

const CallOnWhats = ({ phoneNumber, message }) => {
    const handleClick = () => {
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    };
    return (
        <div className="section-container" style={{ "backgroundColor": "#226b07", "cursor": "pointer" }} onClick={handleClick}>
            <div className='text-column-line'>
                <h3 className='white large'> Ainda com dúvida?</h3>
                <h4 className='white'> Me chama no Zap!</h4>
                <FaWhatsapp style={{ "color": "white", "fontSize": "40px", "paddingBottom": "10px" }} />
            </div>
        </div>
    );
};

export default CallOnWhats;
